import { create } from 'zustand'

interface BranchItem {
  id: string
  name: string
  subtitle?: string
  badge?: "VIP" | "NEW"
}

interface ServiceItem {
  id: string
  name: string
  description?: string
  price?: number
  duration?: number
}

interface BookingState {
  selectedBranch: BranchItem | null
  selectedService: ServiceItem | null
  selectedDate: string | null
  selectedSlot: any | null
  lastSlotSelectionTime?: number
  bookingType: "self" | "other"
  mode: "booking" | "reschedule"
  appointmentId: string | null // For reschedule
  
  setBookingState: (state: Partial<BookingState>) => void
  resetBookingState: () => void
}

export const useBookingStore = create<BookingState>((set) => ({
  selectedBranch: null,
  selectedService: null,
  selectedDate: null,
  selectedSlot: null,
  bookingType: "self",
  mode: "booking",
  appointmentId: null,

  setBookingState: (state) => set((prev) => ({ ...prev, ...state })),
  resetBookingState: () => set({
    selectedBranch: null,
    selectedService: null,
    selectedDate: null,
    selectedSlot: null,
    bookingType: "self",
    mode: "booking",
    appointmentId: null,
  }),
}))
